var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TablePaginated',{attrs:{"label":"Popular Destinations","sublabel":"What locations do your passengers view the most?","main-list":_vm.itemData,"is-global-percent":_vm.isGlobalPercent,"is-mark-active-item":""},on:{"setActiveItem":_vm.setActiveDestinationItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }